<template>
  <a-modal width="600px" v-model="isShow" :closable="false" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-form-model-item label="使用平台" prop="line_id">
        <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择" @change="orgChange" style="width: 60%">
          <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设定时长" prop="set_duration">
        <a-input v-model.trim="form.set_duration" type="number" placeholder="请输入" style="width: 200px" />
        <span style="color: #ccc; margin-left: 10px">单位：s</span>
      </a-form-model-item>
      <a-form-model-item label="请求次数" prop="request_number">
        <a-input v-model.trim="form.request_number" type="number" oninput="value=value.replace('.', '',).replace('-', '',)" placeholder="请输入" style="width: 200px" />
        <span style="color: #ccc; margin-left: 10px">单位：次</span>
      </a-form-model-item>
      <a-form-model-item label="弹窗类型" prop="popup_type">
        <a-select v-model="form.popup_type" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 60%" @change="handleCancelCategory">
          <a-select-option v-for="item in labelList" :key="item.key" :value="item.key">{{
            item.value
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-radio-group v-model="form.state">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="2">关闭</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { form, rules } from './business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from './business/index'
import api from '@/api/'
import storeGlobal from '@/store/'

const title = {
  Add: '新增',
  Edit: '编辑'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      form: { ...form }
    })
    const labelList = computed(() => {
      return storeGlobal.state.label.data.WEBSITE.FREQUENCY_CONFIG_POPUP_TYPE
    })

    watch(
      () => _this.params,
      async () => {
        state.form = JSON.parse(JSON.stringify({ ..._this.params }))
        const responsible = state.form.responsible_name + '(' + state.form.responsible_number + ')'
        _this.$set(state.form, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    const methods = {
        orgChange(val, selectedOptions) {
        if (val) {
          const select_item = _this.platformList.find((item) => item.id.toString() === val.toString())
          const { project, staff_style, type } = select_item
          state.form.project = project
          state.form.staff_style = staff_style
          state.form.type = type
        } else {
          state.form.line_id = undefined
          state.form.project = undefined
          state.form.staff_style = undefined
          state.form.type = undefined
        }
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          if (valid) {
            if (_this.isEdit) {
              res = await api.frequencyConfigUpdate(data)
            } else {
              res = await api.frequencyConfigCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
         _this.form.state = 1
        _this.isShow = false
      },
      handleCancelCategory() {
        if (!_this.isEdit) {
          _this.form.typeids = []
          _this.form.sync_xml_loc = ''
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labelList
    }
  }
})
</script>
